<template>
  <side-panel-inner headerTitle="Create a User" class="p-user-create" on-close='Users'>
    <template slot="actions">
      <base-button @click="createUser">Create</base-button>
    </template>

    <!-- User Name -->
    <message type="error" v-if="showValidationMessage">
      <h3>Form Invalid</h3>
      <p>Form is invalid, please check and try again.</p>
    </message>
    <user-form v-if="!loading"></user-form>

    <loading v-if="loading"></loading>
  </side-panel-inner>
</template>

<script>
import UserForm from "./UserForm";
import { mapGetters } from "vuex";

export default {
  name: "user-create",

  data() {
    return {
      showValidationMessage: false,
      loading: false,
      currentUser: {},
      user: {
        name: null
      }
    };
  },

  beforeMount() {
    this.$store.commit("users/resetUser");
  },

  methods: {
    createUser() {
      const vm = this;
      this.$validator.validate().then(result => {
        if (!result) {
          vm.validationFailed = true;
        } else {
          const vm = this;
          this.loading = true;
          this.$store
            .dispatch("users/add")
            .then(() => {
              vm.$store.dispatch("CLOSE_PANEL");
            })
            .catch(err => {
              this.loading = false;
            });
        }
      });
    }
  },

  computed: {
    formIsValid() {
      return this.user.name;
    }
  },

  components: {
    UserForm
  }
};
</script>
